import React, { useState } from 'react'
import { CLIENTTAB} from '../../../../Constants';
import Template from 'Components/Templates/Template';
import ClientCaseList from './ClientCaseList';
import Header from 'Components/Header/Header';

function Cases()  {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <>
        <Header />      
        <div className='w-full col-span-6'>
        <ClientCaseList/>
        </div>
    </>
  )
}

export default Cases;